import { PluginAdapter, Resources } from "@validereinc/domain";
import { useGetList } from "./adapterUtils";

export const useListPlugins = useGetList(
  PluginAdapter.getList,
  Resources.PLUGIN
);
